import createAiRouterApi from '@rhg/libs/api/create-ai-router';
import useAuth from '@rhg/libs/auth0/use-auth';
import { useMutation } from '@rhg/libs/react-query';
import { useMemo } from 'react';
import { useActiveCircle } from '../use-active-circle';

interface UpdateConversationTimeSpentParams {
    conversationId: string;
    additionalTimeSpentSeconds: number;
}

export function useUpdateConversationTimeSpent() {
    const { getAccessTokenSilently } = useAuth();
    const { activeCircle: circle } = useActiveCircle();
    const api = useMemo(
        () => createAiRouterApi(getAccessTokenSilently),
        [getAccessTokenSilently]
    );

    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async ({
            conversationId,
            additionalTimeSpentSeconds,
        }: UpdateConversationTimeSpentParams) => {
            if (!circle?.authorizationJWT) {
                throw new Error(
                    'Cannot update conversation time spent without an active circle'
                );
            }

            const response =
                await api.aiRouterRecipientsUpdateConversationTimeSpentV1({
                    recipientId: circle.recipient.id,
                    conversationId,
                    circleAuthorizationToken: circle.authorizationJWT,
                    incrementConversationTimeSpentRequest: {
                        additionalTimeSpentSeconds,
                    },
                });
            return response;
        },
    });

    return {
        updateConversationTimeSpent: mutate,
        updateConversationTimeSpentAsync: mutateAsync,
        ...otherProps,
    };
}
